/**
 * React Query read around `GET /api/prompt-inventory` — feeds the composed-
 * prompt inspector's "System layers" tab (Task 9). Static engine reference
 * data (the same entries for every persona), so unlike
 * `usePersonaComposedPrompt` there's no persona-id in the key or the path,
 * and `staleTime: Infinity` like the composed-prompt query — this doesn't
 * change while the inspector is open.
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { apiClient } from '@/services/apiClient'
import type { PromptInventoryResponse } from '@/types/promptInventory'

export function usePromptInventory(options: {
  enabled: boolean
}): UseQueryResult<PromptInventoryResponse, Error> {
  return useQuery<PromptInventoryResponse, Error>({
    queryKey: ['prompt-inventory'],
    queryFn: () => apiClient.get<PromptInventoryResponse>('/api/prompt-inventory'),
    enabled: options.enabled,
    staleTime: Infinity,
    retry: false,
  })
}
